import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import { formatAsCurrency, isNumber } from 'lib/number';
import { toFormattedOfferOldPrice } from 'lib/offer';
import { toFormattedOfferPrice } from 'lib/offerPage';

const formatValue = (value) =>
  isNumber(value)
    ? formatAsCurrency({ number: value, currency: 'BRL', locale: 'pt-BR' })
    : value;

/**
 * Preço antigo aparece ACIMA (pequeno, riscado) e preço atual abaixo em
 * destaque. Layout segue o mock do Figma — vertical em todas as resoluções,
 * com o atual em tamanho grande (similar ao Pelando/KaBuM). Formatação
 * usa locale `pt-BR`, que aplica "." para milhares e "," para centavos.
 */
const OfferPrice = ({
  className,
  offerOldPrice = null,
  offerPrice,
  offerPriceType,
}) => {
  const primary = toFormattedOfferPrice(offerPrice, offerPriceType);
  const secondary = toFormattedOfferOldPrice(offerOldPrice, offerPriceType);
  const formattedPrimary = formatValue(primary);
  const formattedSecondary = formatValue(secondary);

  return (
    <div className={twMerge('flex flex-col items-start gap-y-1.5', className)}>
      {formattedSecondary && (
        <Text
          as="span"
          className={twMerge(
            'whitespace-nowrap text-base font-regular leading-none text-neutral-high-500 dark:text-neutral-high-400',
            isNumber(secondary) && 'line-through'
          )}
          size="size2"
        >
          {formattedSecondary}
        </Text>
      )}
      <Heading
        as="span"
        className="whitespace-nowrap text-[32px] font-bold leading-none text-neutral-low-500 dark:text-neutral-high-200 lg:text-[48px]"
        size="size1"
      >
        {formattedPrimary}
      </Heading>
    </div>
  );
};

OfferPrice.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offerOldPrice: PropTypes.number,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
};

export default OfferPrice;
